import { isDefined, isFunction, isObject } from "./type";

export const EMPTY = {};
export const omitField = (obj, field) => {
  const { [field]: _, ...without } = obj;

  return without;
};

export const deepExtend = (target, values) => {
  if (isObject(target) && isObject(values)) {
    return Object.keys(values).reduce((acc, key) => {
      acc[key] = deepExtend(target[key], values[key]);

      return acc;
    }, { ...target });
  }

  if (isDefined(values)) {
    return values;
  }

  return target;
};

const getValue = value => isFunction(value) ? value() : value;
export const conditionalObj = (obj, ...conditions: { if: boolean; value: any; else?: any }[]) => {
  for (const condition of conditions) {
    if (condition.if) {
      Object.assign(obj, getValue(condition.value));
    } else if (condition.else) {
      Object.assign(obj, getValue(condition.else));
    }
  }

  return obj;
};

export const cleanCircluarRefs = (obj, visited = new Set()) => {
  if (Array.isArray(obj)) {
    return obj.map(item => cleanCircluarRefs(item, visited));
  }

  if (isObject(obj)) {
    if (visited.has(obj)) {
      return null;
    }
    visited.add(obj);
    const result = Object.keys(obj).reduce((acc, key) => {
      acc[key] = cleanCircluarRefs(obj[key], visited);
      return acc;
    }, {});

    visited.delete(obj);

    return result;
  }

  return obj;
};

export const cleanCircluarRefsMap = obj => cleanCircluarRefs(obj);
